import TermsAndPrivacy, { TermsAndPrivacyProps } from './TermsAndPrivacy';

export type { TermsAndPrivacyProps };
export default TermsAndPrivacy;